import { Checkbox, Form, Input, Select } from 'antd';
import { useContext, useMemo } from 'react';

import { SCard } from 'app/components/StaycationUI';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { MarkdownPreview } from 'app/components/commons/MarkdownPreview/MarkdownPreview';
import { TooltipLabel } from 'app/components/commons/TooltipLabel/TooltipLabel';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useCustomTags } from 'app/hooks/data/useCustomTags';
import type { PackResponse } from 'app/typings/core/admin/packs/pack';

import './Copywriting.scss';

export const Copywriting = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance<Partial<PackResponse>>();

  const isDaytime = Form.useWatch('isDaytime', form);
  const description = Form.useWatch('description', form);

  const { data: customTags } = useCustomTags();
  const options = useMemo(
    () =>
      customTags?.map((customTag) => ({
        label: customTag.name,
        value: customTag.id,
        searchKey: customTag.name,
      })),
    [customTags]
  );

  return (
    <div className="storytelling-content">
      <div className="storytelling-left-column">
        <SCard title="Storytelling" className="storytelling-form">
          <div className="storytelling-fields">
            <FormLineLayout label="Custom tags">
              <Form.Item name="customTagIds" valuePropName="value">
                <Select
                  showSearch
                  options={options}
                  mode="multiple"
                  disabled={!isEditMode}
                  filterOption={(input, option) =>
                    option?.label
                      ?.toLowerCase()
                      .includes(input.toLowerCase()) ?? false
                  }
                />
              </Form.Item>
            </FormLineLayout>
            <FormLineLayout label="Gem">
              <Form.Item name="isGem" valuePropName="checked">
                <Checkbox disabled={!isEditMode}>
                  Allow this offer to be featured on the product homepage
                </Checkbox>
              </Form.Item>
            </FormLineLayout>

            {isDaytime && (
              <FormLineLayout
                labelOnTop
                label={<TooltipLabel label="Description" />}
                isRequired
              >
                <Form.Item name="description" valuePropName="value">
                  {isEditMode ? (
                    <Input.TextArea rows={4} />
                  ) : (
                    <div className="view-data">{description || 'ø empty'}</div>
                  )}
                </Form.Item>
              </FormLineLayout>
            )}
          </div>
          <Form.Item name="disclaimers" noStyle />
        </SCard>
      </div>
      {isEditMode && isDaytime && <MarkdownPreview values={{ description }} />}
    </div>
  );
};
